// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';
import { clientAppUuid } from '../../../../services/helpers';

export const createBulkCnTicketActions = {
  CREATE_BULK_CN: 'CREATE_BULK_CN'
};

export const createBulkCnAction = (obj: Object) => ({
  type: createBulkCnTicketActions.CREATE_BULK_CN,
  payload: obj
});

export const createBulkCn = (bookingDetails: Object, counter: Object) => (
  dispatch: Function
) => {
  dispatch(
    createBulkCnAction({
      data: null
    })
  );
  const requestObj = {
    baseUrl: 'clientIntegrationApiUrl',
    apiEndPoint: 'createBulkCn',
    data: bookingDetails,
    method: 'POST',
    headersData: {
      appUuid: clientAppUuid
    },

    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          createBulkCnAction({
            jsonFile: null,
            counter: counter + 1
          })
        );
        toastr.success(
          `Success Booking Created for CN number: ${counter + 1}`,
          res.errorMessage,
          {
            timeout: 3000
          }
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          createBulkCnAction({
            jsonFile: null,
            postCallFailed: true
          })
        );
        if (res.statusCode === 406) {
          toastr.error(
            `Failure Booking for CN number: ${counter + 1}`,
            res.errorMessage,
            {
              timeout: 3000
            }
          );
        } else {
          toastr.error(
            `Failure Booking for CN number: ${counter + 1}`,
            res.errorMessage,
            {
              timeout: 3000
            }
          );
        }
      }
    },
    failureCb: res => {
      dispatch(
        createBulkCnAction({
          jsonFile: null,
          postCallFailed: true
        })
      );
      toastr.error(
        `Failure Booking for CN number: ${counter + 1}`,
        res.errorMessage,
        {
          timeout: 3000
        }
      );
    },
    catchCb: res => {
      dispatch(
        createBulkCnAction({
          jsonFile: null,
          postCallFailed: true
        })
      );
      toastr.error(
        `Failure Booking for CN number: ${counter + 1}`,
        res.errorMessage,
        {
          timeout: 3000
        }
      );
    }
  };
  return makeApiCall(requestObj);
};
